import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { ApiAccessKeyReducer } from '@leverege/api-redux';
import I18N from '@leverege/i18n';
import AddEditApiAccessKeysDialog from "../apiAccessKey/AddEditApiAccessKeysDialog.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('apiAccessKeyManagement.action.EditApiAccessKey');
export default {
  id: 'apiAccessKeyManagement.action.ContextEditApiAccessKey',
  type: 'ApiAccessKeys.edit',
  name: tf('name'),
  layout: {
    sort: 'accessManagement.b',
    sectionName: 'Access Management'
  },
  matches: {
    use: 'contextMenu',
    client: 'ApiAccessKeys'
  },
  prepare: async context => {
    const {
      clientProps: {
        actions,
        allowed,
        dispatch
      }
    } = context;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    if (targets?.length !== 1) {
      return null;
    }
    const promises = [];
    if (typeof allowed.updateApiAccessKey !== 'boolean') {
      promises.push(dispatch(actions.apiAccessKey(targets[0]).canUpdate()));
    }
    if (typeof allowed.assignUserRoles !== 'boolean') {
      promises.push(dispatch(actions.users().canAssignRoles()));
    }
    return Promise.all(promises);
  },
  isPrepared: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    if (targets?.length !== 1) {
      return true;
    }
    return typeof allowed.updateApiAccessKey === 'boolean' && typeof allowed.assignUserRoles === 'boolean';
  },
  handles: context => {
    const {
      clientProps: {
        allowed
      }
    } = context;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    return targets?.length === 1 && allowed.updateApiAccessKey === true && allowed.assignUserRoles === true;
  },
  appearance: opts => {
    const name = t('appearanceName');
    const icon = tIcon('edit', '@icon:edit');
    return {
      name,
      icon
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        projectId,
        resourceId,
        actions,
        selectorProps
      },
      emailOptions,
      smsOptions,
      uiName
    } = context;
    const targets = Context.getTargetsOfType(context, 'apiAccessKey');
    const apiAccessKey = ApiAccessKeyReducer.getApiAccessKey(GlobalState.get(), resourceId, targets?.[0]);
    Dialogs.show({
      component: AddEditApiAccessKeysDialog,
      props: {
        projectId,
        actions,
        apiAccessKey,
        selectorProps,
        emailOptions,
        smsOptions,
        uiName
      }
    });
  }
};